// extracted by mini-css-extract-plugin
export default {"tabsBox":"nUgjqMAM4BF6RoXjbUPH"};